var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { request } from "../services/requestService";
import { MANAGING_WORKSPACE_ID } from "../../src/constants";
var requestType;
(function (requestType) {
    requestType["get"] = "get";
    requestType["post"] = "post";
    requestType["put"] = "put";
    requestType["patch"] = "patch";
    requestType["delete"] = "delete";
})(requestType || (requestType = {}));
function getCookie(name) {
    var value = "; ".concat(document.cookie);
    var parts = value.split("; ".concat(name, "="));
    // Check if parts have the desired cookie value
    if (parts.length === 2) {
        var tokenPart = parts.pop();
        return tokenPart ? tokenPart.split(";").shift() : null;
    }
    return null;
}
export var useRequest = function () {
    var refreshAuthToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currentToken, response, newToken, expirationDate, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    currentToken = getCookie("dw_c_auth");
                    return [4 /*yield*/, request.post("/externalAuth/refresh-token", null, {
                            headers: {
                                Authorization: "Bearer ".concat(currentToken), // Include the current token in the refresh request
                            },
                        })];
                case 1:
                    response = _a.sent();
                    newToken = response.data.token;
                    expirationDate = new Date();
                    expirationDate.setMonth(expirationDate.getMonth() + 36); // Expire in 36 months
                    document.cookie = "dw_c_auth=".concat(newToken, "; expires=").concat(expirationDate.toUTCString(), "; path=/; Secure; SameSite=Lax;");
                    return [2 /*return*/, newToken];
                case 2:
                    error_1 = _a.sent();
                    // Check if the error response contains a redirect URL
                    if (error_1.response && error_1.response.data && error_1.response.data.redirectUrl) {
                        // Redirect to the specified URL
                        window.location.href = error_1.response.data.redirectUrl;
                    }
                    else {
                        // Default redirect URL if none is provided
                        window.location.href = "https://openid.phonexa.com/auth/customer-login/";
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var requestHandler = function (type) {
        return function (url, data, configs) { return __awaiter(void 0, void 0, void 0, function () {
            var storageIid, jwtToken, requestConfigs, _a, error_2, newJwtToken, requestConfigs_1, _b;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        storageIid = localStorage.getItem("iid");
                        jwtToken = getCookie("dw_c_auth");
                        requestConfigs = __assign(__assign({}, configs), { headers: __assign(__assign(__assign(__assign({}, configs === null || configs === void 0 ? void 0 : configs.headers), { "x-managingworkspaceid": MANAGING_WORKSPACE_ID }), (storageIid && type === requestType.get && { iid: storageIid })), (jwtToken && { Authorization: "Bearer ".concat(jwtToken) })) });
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, , 13]);
                        if (![requestType.get, requestType.delete].includes(type)) return [3 /*break*/, 3];
                        return [4 /*yield*/, request[type](url, requestConfigs)];
                    case 2:
                        _a = _d.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, request[type](url, data, requestConfigs)];
                    case 4:
                        _a = _d.sent();
                        _d.label = 5;
                    case 5: return [2 /*return*/, _a];
                    case 6:
                        error_2 = _d.sent();
                        if (!(((_c = error_2.response) === null || _c === void 0 ? void 0 : _c.status) === 401)) return [3 /*break*/, 12];
                        return [4 /*yield*/, refreshAuthToken()];
                    case 7:
                        newJwtToken = _d.sent();
                        if (!newJwtToken) return [3 /*break*/, 12];
                        requestConfigs_1 = __assign(__assign({}, configs), { headers: __assign(__assign(__assign(__assign({}, configs === null || configs === void 0 ? void 0 : configs.headers), { "x-managingworkspaceid": MANAGING_WORKSPACE_ID }), (storageIid && type === requestType.get && { iid: storageIid })), (newJwtToken && { Authorization: "Bearer ".concat(newJwtToken) })) });
                        if (![requestType.get, requestType.delete].includes(type)) return [3 /*break*/, 9];
                        return [4 /*yield*/, request[type](url, requestConfigs_1)];
                    case 8:
                        _b = _d.sent();
                        return [3 /*break*/, 11];
                    case 9: return [4 /*yield*/, request[type](url, data, requestConfigs_1)];
                    case 10:
                        _b = _d.sent();
                        _d.label = 11;
                    case 11: return [2 /*return*/, _b];
                    case 12: throw error_2;
                    case 13: return [2 /*return*/];
                }
            });
        }); };
    };
    return {
        get: requestHandler(requestType.get),
        put: requestHandler(requestType.put),
        patch: requestHandler(requestType.patch),
        post: requestHandler(requestType.post),
        delete: requestHandler(requestType.delete),
    };
};
